module.exports = __webpack_public_path__ + "img/laptop-your-brand.9328e59e.svg";